<template>
    <div v-if="props.link.mode === 'group'">

        <div @click="toggle" class="block cursor-pointer hover:bg-secondary-600 transition-all duration-400" target="_blank" :class="open ? ['bg-secondary-600'] : ''">

            <div class="px-5 py-5 sm:px-6">
                <div class="flex items-center justify-between">
                    <div class="flex-none">
                        <ChevronRightIcon class="h-12 w-12 text-secondary-700" v-if="!open" />
                        <ChevronDownIcon class=" h-12 w-12 text-secondary-700" v-if="open" />
                    </div>
                    <div class="flex-auto text-sm md:text-base font-medium text-tertiary-600">
                        {{ props.link.title }}</div>
                    <div class="ml-2 flex-shrink-0">
                        <p class="inline-flex rounded-full bg-gray-200 px-2 text-xs font-semibold leading-5 text-gray-800">{{ props.link.type.toUpperCase() }}</p>
                    </div>
                </div>
            </div>
        </div>


        <div class="submenue" v-show="open">
            <div v-for="(sub, val) in props.link.sub" :key="sub">
                <a :href="sub.link" @click="countClick(val, props.link.id, sub.clicks)" class="block hover:bg-secondary-600 transition-all duration-200" target="_blank">
                    <div class="px-5 py-5 sm:px-6">
                        <div class="flex items-center justify-between">

                            <div class="text-sm md:text-base font-medium text-tertiary-600">{{ sub.title }} <ClickStats :clicks="sub.clicks" v-if="props.uid" /></div>
                            <div class="ml-2 flex flex-shrink-0">
                                <p class="inline-flex rounded-full bg-gray-200 px-2 text-xs font-semibold leading-5 text-gray-800">{{ sub.type.toUpperCase() }}</p>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps, ref, defineEmits } from 'vue';
import { ChevronRightIcon, ChevronDownIcon} from '@heroicons/vue/20/solid';
import ClickStats from './Click-Stats.vue';
const props = defineProps(['link', 'uid'])
const open = ref(false)
const emits = defineEmits(['count'])


const countClick = (id, parent_id, clicks) => {
    emits('count', [id, parent_id, clicks])
}
const toggle = () => {
    open.value = open.value == false ? true : false;
}

</script>